import { render } from "./App.vue?vue&type=template&id=056a403a"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Codes\\Single Pages\\Artytech\\old_hp\\artytech_build\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__